import { takeEvery, call, all, put, fork } from "redux-saga/effects";
import { SIGN_OUT } from "./action";
import reduxSagaFirebase from "../../common/reduxSagaFirebase";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { actionCreators as actionCreatorsResult } from "../../test/action";
import { actionCreators as actionCreatorsRegistrationForm } from "./../RegistrationForm/action";
import { actionCreators as actionCreatorsFotterMenu } from "../../FooterMenu/action";
import { actionCreators as actionCreatorsSpinner } from "../Spinner/action";

export function* onSignOutSaga() {
  try {
    yield put(actionCreatorsSpinner.showSpinner());
    const data = yield call(reduxSagaFirebase.auth.signOut);
    yield put(actionCreatorsRegistrationForm.signOut());
    yield put(actionCreatorsResult.saveTest(null));
    yield put(actionCreatorsFotterMenu.setActiveFooterMenu(0));
    yield call(AsyncStorage.removeItem, "authUserData");
    yield put(actionCreatorsSpinner.hideSpinner());
  } catch (error) {
    // console.log(error);
    yield put(actionCreatorsSpinner.hideSpinner());
  }
}

export function* signOutSaga() {
  yield takeEvery(SIGN_OUT, onSignOutSaga);
}

export function* signOutAllSaga() {
  yield all([fork(signOutSaga)]);
}
